<template>
  <div class="modal-overlay" @click.self="cerrarModal">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Anexos - {{ nombre_doc }}</h5>
        <button type="button" class="close" @click="cerrarModal">
          <span>&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div v-if="archivos.length === 0" class="alert alert-light border mb-0">
          No hay anexos para este documento.
        </div>
        <ul v-else class="list-group">
          <li
            v-for="archivo in archivos"
            :key="archivo.id || archivo.url || archivo.nombre"
            class="list-group-item d-flex justify-content-between align-items-center"
          >
            <span class="archivo-nombre text-truncate pr-2">{{ archivo.nombre }}</span>
            <button
              class="btn btn-sm btn-outline-primary archivo-btn"
              @click="descargarArchivo(archivo.url)"
            >
              <i class="fa fa-regular fa-eye"></i>
            </button>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import axiosInstance from "../../services/axiosInstance";

export default {
  name: "ModalInspectorFiles",
  props: {
    visible: Boolean,
    nombre_doc: String,
    archivos: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    cerrarModal() {
      this.$emit("close-modal");
    },
    descargarArchivo(nombreArchivo) {
      if (!nombreArchivo) return;

      axiosInstance
        .post("/pam/vistaPreviaArchivo", { file: nombreArchivo })
        .then((response) => {
          if (response.data) {
            window.open(response.data, "_blank", "noopener");
          }
        })
        .catch(() => {
          this.flashMessage.error({
            message: "[ERROR]: Ocurrió un error al descargar el archivo.",
          });
        });
    },
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.285);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}

.modal-content {
  width: 92%;
  max-width: 700px;
  border-radius: 12px;
  overflow: hidden;
}

.modal-header {
  background: #f8f9fa;
}

.modal-body {
  max-height: 70vh;
  overflow-y: auto;
  overflow-x: hidden;
}

.archivo-nombre {
  flex: 1 1 auto;
  min-width: 0;
  max-width: 100%;
  display: block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.archivo-item {
  min-width: 0;
  gap: 8px;
  width: 100%;
  max-width: 100%;
}

.archivo-btn {
  flex: 0 0 36px;
}

.list-group {
  width: 100%;
}

.list-group-item {
  max-width: 100%;
  box-sizing: border-box;
}
</style>
